import styles from './styles.module.scss';
import { useAppContext } from 'context/AppContext';
import { POPUP_CONTENT } from 'components/AiMode/constants';
import { Modal, ModalSize } from 'packages/radiant-react/modal';
import { Colors, Typography } from 'packages/radiant-react/typography';

function MessageInfoPopUp() {
  const { popUpMessageType, setPopUpMessageType } = useAppContext();

  return (
    <Modal
      isOpen={popUpMessageType !== ''}
      size={ModalSize.SMALL}
      title={POPUP_CONTENT[popUpMessageType]?.['title'] ?? ''}
      dismissButton={{
        text: POPUP_CONTENT[popUpMessageType]['dismissText'],
      }}
      confirmButton={{
        onConfirm: () => {
          setPopUpMessageType('');
        },
        text: POPUP_CONTENT[popUpMessageType]['confirmText'],
      }}
      noPadding
      onDismiss={() => {
        setPopUpMessageType('');
      }}
    >
      <Typography variant="p" color={Colors.base} className={styles['info']}>
        {POPUP_CONTENT[popUpMessageType]['para']}
      </Typography>
    </Modal>
  );
}

export default MessageInfoPopUp;
